"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.364 10.027a5.68 5.68 0 0 0 3.78 5.31c.396.143.576.363.573.7-.005.49-.461.797-.953.633a6.8 6.8 0 0 1-2.537-1.515C4 14.001 3.26 12.582 3.058 10.913c-.255-2.108.33-3.982 1.742-5.574C5.965 4.027 7.445 3.28 9.18 3.056c3.408-.441 6.714 1.776 7.608 5.088.115.426-.075.803-.461.914-.385.11-.74-.118-.873-.537-.715-2.276-2.25-3.656-4.598-4.061-2.969-.512-5.891 1.616-6.38 4.595-.052.321-.075.648-.112.972"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.465 9.19a2.22 2.22 0 0 1 2.243 2.241c0 1.226-1.015 2.227-2.253 2.222a2.25 2.25 0 0 1-2.248-2.25c.005-1.23 1.012-2.216 2.258-2.214m.004 1.284c-.541-.002-.98.424-.976.948.003.515.448.95.966.947a.96.96 0 0 0 .963-.946.94.94 0 0 0-.953-.949m-3.541 5.675a1.93 1.93 0 0 1 1.975-2.011c1.036.015 2.073.001 3.11.004 1.164.002 1.989.831 1.987 1.997 0 .129 0 .261-.03.385a.63.63 0 0 1-.701.471.65.65 0 0 1-.554-.622c-.006-.153.002-.31-.027-.459a.595.595 0 0 0-.524-.478 2 2 0 0 0-.258-.013c-.956 0-1.913.014-2.869-.007-.529-.011-.875.253-.828.824.027.315-.088.573-.394.707a.633.633 0 0 1-.887-.563c-.004-.086 0-.172 0-.235m.785-7.608v1.87c-.002.48-.267.75-.741.752q-1.492.004-2.983 0c-.39-.002-.656-.24-.71-.619-.044-.313.176-.64.499-.731a1 1 0 0 1 .256-.026c.698-.001 1.396-.006 2.094.003.162.002.21-.042.21-.207q-.011-1.48-.003-2.962c.003-.507.44-.831.904-.681.292.094.471.343.473.677q.003.963.001 1.925"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=RequestsIcon20.js.map